import React, { useState, useEffect } from 'react';
import { Calendar, Badge, Card, Typography, Spin, Alert, Select, Row, Col } from 'antd';
import { getEvents } from '../services/eventsService';
import dayjs from 'dayjs';

const { Text } = Typography;

function EventsCalendar() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getEvents();
        setEvents(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const dateCellRender = value => {
    const dateEvents = events.filter(event => {
      const eventDate = dayjs(event.start_date);
      return (
        eventDate.date() === value.date() &&
        eventDate.month() === value.month() &&
        eventDate.year() === value.year()
      );
    });

    return (
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {dateEvents.map(event => (
          <li key={event.id}>
            <Badge
              status="processing"
              text={
                <Text
                  ellipsis
                  style={{ cursor: 'pointer' }}
                  onClick={() => window.open(event.ticket_url, '_blank')}
                >
                  {event.name}
                </Text>
              }
            />
          </li>
        ))}
      </ul>
    );
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '24px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '24px' }}>
        <Alert message={error} type="error" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Calendar
          dateCellRender={dateCellRender}
          mode="month"
          fullscreen={true}
          headerRender={({ value, type, onChange, onTypeChange }) => {
            const start = 0;
            const end = 12;
            const monthOptions = [];

            const months = [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December',
            ];

            for (let i = start; i < end; i++) {
              monthOptions.push(
                <Select.Option key={i} value={i}>
                  {months[i]}
                </Select.Option>
              );
            }

            return (
              <div style={{ padding: 8 }}>
                <Row gutter={8} justify="end">
                  <Col>
                    <Select
                      value={value.month()}
                      onChange={newMonth => {
                        const now = value.clone().month(newMonth);
                        onChange(now);
                      }}
                    >
                      {monthOptions}
                    </Select>
                  </Col>
                </Row>
              </div>
            );
          }}
        />
      </Card>
    </div>
  );
}

export default EventsCalendar;
